export const defaultValueEndowment = {
    firstName: '',
        secondName: '',
        surname: '',
        secondSurname: '', 
        gender: '',
        regionalId: '',
        deliverDate: '',
        sizeShirt: '',
        amountShirt: '',
        pijamaSize: '',
        pijamaAmount: '',
        sueterSize: '',
        sueterAmount: '',
        pantsSize: '',
        pantsAmount: '',
        shoesSize: '',
        shoesAmount: '',
        licenseSize: '',
        licenseAmount: '',
}

export const listAmount = [
    {id:0, value: 0},
    {id:1, value: 1},
    {id:2, value: 2},
    {id:3, value: 3},
    {id:4, value: 4},
    {id:5, value: 5},
    {id:6, value: 6},
    {id:7, value: 7},
    {id:8, value: 8},
    {id:9, value: 9},
    {id:10, value: 10}
];

export const defaultValueSearch = {
    firstName: '',
    surname: '', 
    documentType: '',
    document: '',
    deliverDate: '',
    regional: '',
    initDate: '',
    endDate: ''
}

export const headers = {
    initialHeaders: [
        { title: "Nombre del empleado", field: "fullName", child: null },
        { title: "Tipo de documento", field: "documentType", child: null },
        { title: "Número de documento", field: "document", child: null },
        { title: "Fecha de creación", field: "creationDate", child: null,},
        {title: "Regional", field: "regional", child: null,},
        {title: "Estado", field: "status", child: null,},
    ],
    othersHeaders: [
        { title: "Primer nombre", field: "firstName", child: null },
        { title: "Segundo nombre", field: "secondName", child: null },
        { title: "Primer apellido", field: "surname", child: null },
        { title: "Segundo apellido", field: "secondSurname", child: null,},
        {title: "Regional", field: "regional", child: null,},
        { title: "Tipo de documento", field: "documentType", child: null },
        { title: "Número de documento", field: "document", child: null },
        { title: "Fecha de entrega", field: "deliveryDate", child: null,}
    ]
};